export const getCountriesApi = async (search = "") => {
  try {
    // Primary API - restcountries.com
    const url = `https://api.restcountries.com/countries/v5?q=${search || "a"}&limit=10`;
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_RESTCOUNTRIES_KEY}`,
      },
    });

    if (!response.ok) {
      throw new Error("Primary API failed");
    }

    const data = await response.json();
    return data.slice(0, 10).map((country) => ({
      name: country.name.common,
      currency: Object.keys(country.currencies || {})[0] || "USD",
      isoCode: country.cca2,
      countryCode: country.idd?.root
        ? country.idd.root + (country.idd?.suffixes?.[0] || "")
        : "",
    }));
  } catch (error) {
    console.log("Primary API failed, using fallback API");

    try {
      // Fallback API - countriesnow.space
      const fallbackResponse = await fetch(
        "https://countriesnow.space/api/v0.1/countries/codes",
      );

      const fallbackData = await fallbackResponse.json();

      return fallbackData.data
        .filter((country) =>
          country.name.toLowerCase().includes(search.toLowerCase()),
        )
        .slice(0, 10)
        .map((country) => ({
          name: country.name,
          currency: "USD",
          isoCode: country.code,
          countryCode: "",
        }));
    } catch (fallbackError) {
      console.error("Fallback API also failed", fallbackError);
      return [];
    }
  }
};

export const getAllCountriesApi = async () => {
  try {
    // Primary API - restcountries.com
    const response = await fetch(
      "https://api.restcountries.com/countries/v5",
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_RESTCOUNTRIES_KEY}`,
        },
      },
    );

    if (!response.ok) {
      throw new Error("Primary API failed");
    }

    const data = await response.json();
    return data.slice(0, 10).map((country) => ({
      name: country.name.common,
      currency: Object.keys(country.currencies || {})[0] || "USD",
      isoCode: country.cca2,
      countryCode: country.idd?.root
        ? country.idd.root + (country.idd?.suffixes?.[0] || "")
        : "",
    }));
  } catch (error) {
    console.log("Primary API failed, using fallback API");

    try {
      // Fallback API - countriesnow.space
      const fallbackResponse = await fetch(
        "https://countriesnow.space/api/v0.1/countries/codes",
      );

      const fallbackData = await fallbackResponse.json();

      return fallbackData.data.slice(0, 10).map((country) => ({
        name: country.name,
        currency: "USD",
        isoCode: country.code,
        countryCode: "",
      }));
    } catch (fallbackError) {
      console.error("Fallback API also failed", fallbackError);
      return [];
    }
  }
};
